import React from 'react'
import styled from 'styled-components'
import Dropdown from 'components/Dropdown'
import { DropdownProps } from 'components/Dropdown/Dropdown'
import Select, { Label } from 'components/Select'
import { Flex, Text } from 'components/Box'
import { buttonUnstyledStyles } from 'components/Button'
import { PopoverContent, PopoverArrow } from 'components/Popover'

import { ReactComponent as chevronIcon } from 'icons/chevron-vertical-12.svg'
import theme from 'styles/theme'

import { ReactComponent as BellIconPartial } from 'icons/bell-half-20.svg'
import { ReactComponent as BellIconOn } from 'icons/bell-checkmark-20.svg'
import { ReactComponent as BellIconOff } from 'icons/bell-slash-20.svg'

import { Status } from './types'

const BaseFollowDropdown: React.FC<DropdownProps> = props => (
  <Dropdown spacing="12px" placement="bottom-end" {...props} />
)

export const FollowDropdown = styled(BaseFollowDropdown)`
  & + ${/* sc-selector */ PopoverContent} > ${/* sc-selector */ PopoverArrow} {
    &:before,
    &:after {
      transform: translateX(120px);
    }
  }
`

export const FollowDropdownTrigger = styled(Flex).attrs({ as: 'button' })`
  ${buttonUnstyledStyles};

  width: 100%;
  height: 32px;

  align-items: center;

  text-align: left;
  user-select: none;

  background-color: ${({ theme }) => theme.colors.background.light.base};
  color: ${({ theme }) => theme.colors.text.dark.secondary};
  transition: border-color ${({ theme }) => theme.transitions.duration[1]};

  border: 1px solid ${({ theme }) => theme.colors.border.dark.high};
  border-radius: 4px;

  [aria-expanded='true'] & {
    background-color: ${({ theme }) => theme.colors.border.dark.base};
  }

  &:focus {
    border-color: ${({ theme }) => theme.colors.border.dark.ultraHigh};
  }
`

export const FollowDropdownChevronIcon = styled(chevronIcon)`
  width: 12px;
  height: 12px;
  margin-right: 6px; /* stylelint-disable-line scales/space */

  justify-self: flex-end;

  color: ${({ theme }) => theme.colors.gray};
`

export const FollowDropdownBellIcon = ({ status }: { status: Status }) => {
  const svgAttr = {
    width: 20,
    height: 20,
    color: theme.colors.gray,
  }

  switch (status) {
    case 'PARTIAL':
      return <BellIconPartial {...svgAttr} />
    case 'ON':
      return <BellIconOn {...svgAttr} />
    case 'OFF':
      return <BellIconOff {...svgAttr} />
  }
}

export const FollowDropdownContent = styled.div`
  width: 280px;
`

export const FollowDropdownDivider = Dropdown.Divider

export const FollowDropdownAction = styled(Select.Option)`
  & ~ &:last-child {
    margin-bottom: 0;
  }
`

export const FollowDropdownLabel: React.FC = ({ children }) => (
  <Label fontSize="little" ml={3} mt={0} mb={0} lineHeight={1.2}>
    {children}
  </Label>
)

export const FollowDropdownDescription: React.FC = ({ children }) => (
  <Text fontSize="small" color="gray" py={0} px={4} mt={2} mb={4}>
    {children}
  </Text>
)
